import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { DocumentosSAPContent } from './components/DocumentosSAPContent';

export default function DocumentosSAP() {
  return (
    <>
      <MainContent
        titulo='Documentos SAP'
        component={<DocumentosSAPContent />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}